<script setup lang="ts">
import '@/assets/scss/form.scss'
import { APIClient } from '@/onenetwork/core/onenetwork.api.instant.ts'
import { yupResolver } from '@primevue/forms/resolvers/yup'
import { useConfirm } from 'primevue'
import { useToast } from 'primevue/usetoast'
import { ref, watch } from 'vue'
import RealestateAPI from '../constants/realestate.api.uri.const'
import { HISTORY_OPTIONS } from '../constants/realestate.const'
import { schemaAssetHistory } from '../helper/schema'
import moment from 'moment'

const confirm = useConfirm()

interface Props {
  id: any
  closeModal?: any
}

const props = defineProps<Props>()
const emit = defineEmits(['update:closeModal'])
const toast = useToast()
const _date: any = ref(new Date())

const initialValues = ref({
  type: '',
  value: '',
  title: '',
  date: '',
})
const resolver = yupResolver(schemaAssetHistory)

const requestCreate = async (values: any) => {
  const data = {
    real_estate_id: props.id,
    type: values.type?.code || '',
    value: values.value,
    title: values.title || '',
    date: moment(_date.value).format('YYYY-MM-DD HH:mm:ss'), // Format date to match backend expectations
  }
  try {
    const res = await APIClient.post(RealestateAPI.history.create, data)
    if (res.data.code === 200) {
      //close modal
      toast.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Tạo lịch sử thành công',
        life: 3000,
      })
      emit('update:closeModal')
      return
    }
  } catch (e) {
    const errorMessage = e.response?.data?.errors[0]?.error || 'An error occurred'
    toast.add({ severity: 'error', summary: 'Error', detail: errorMessage, life: 3000 })
  }
}

const onFormSubmit = ({ values, valid }: any) => {
  if (!valid) {
    return
  }
  confirm.require({
    message: 'Bạn có muốn tạo lịch sử không?',
    header: 'Xác nhận',
    // icon: 'pi pi-exclamation-triangle',
    rejectProps: {
      label: 'Huỷ',
      severity: 'secondary',
      outlined: true,
    },
    acceptProps: {
      label: 'Đồng ý',
    },
    accept: () => {
      requestCreate(values)
    },
    reject: () => {
      // toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
    },
  })
}
</script>

<template>
  <div class="pt-3">
    <Form
      v-slot="$form"
      :initial-values="initialValues"
      :resolver="resolver"
      @submit="onFormSubmit"
      class="flex flex-col w-full"
    >
      <InputText name="user_id" type="hidden" class="form-control" />
      <div class="flex flex-col flex-3">
        <div class="flex mb-3 gap-3">
          <div class="flex-1 text-right">Chọn trường dữ liệu:</div>
          <div class="flex-2">
            <Select
              name="type"
              :options="[
                ...HISTORY_OPTIONS.map((item: any) => ({ name: item.label, code: item.value })),
              ]"
              optionLabel="name"
              placeholder="Chọn trường dữ liệu"
              class="form-control"
            />
            <span class="font-italic text-[12px] text-red-500">
              {{ $form?.type?.error?.message }}
            </span>
          </div>
        </div>
        <div class="flex mb-3 gap-3">
          <div class="flex-1 text-right">Tiêu đề:</div>
          <div class="flex-2">
            <InputText name="title" type="text" class="form-control" />
            <span class="font-italic text-[12px] text-red-500">
              {{ $form?.title?.error?.message }}
            </span>
          </div>
        </div>
        <div class="flex mb-3 gap-3">
          <div class="flex-1 text-right">Giá trị mới:</div>
          <div class="flex-2">
            <InputText name="value" type="text" class="form-control" />
            <span class="font-italic text-[12px] text-red-500">
              {{ $form?.value?.error?.message }}
            </span>
          </div>
        </div>
        <div class="flex mb-3 gap-3">
          <div class="flex-1 text-right">Ngày cập nhật:</div>
          <div class="flex-2">
            <DatePicker :manual-input="true" v-model="_date" class="form-control w-full" />
            <InputText hidden name="date" type="text" class="form-control" />
            <span class="font-italic text-[12px] text-red-500">
              {{ $form?.date?.error?.message }}
            </span>
          </div>
        </div>
        <div class="flex mb-3 gap-3">
          <div class="flex-1 text-right"></div>
          <div class="flex-2">
            <button type="submit" class="btn btn-cs primary lg">Lưu</button>
          </div>
        </div>
      </div>
    </Form>
  </div>
</template>
